import SamplesPinner from 'decentralized/pinner/samplesPinner.js';
import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ethereum from 'decentralized/ethereum.js';
import ipfs from 'decentralized/Ipfs.js';
import '../Pinner.scss';

class PinnerComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            downloading: false,
            stats: {
                date: new Date(),
                local: new Set(),
                pinned: new Set(),
                pinning: new Set(),
                failed: new Set(),
                queued: new Set(),
            },
            counter: 0,
            filesDownloading: {},
            tagsDownloading: {},
            notConnected: false,
        };

        this.samplesPinner = new SamplesPinner();

        setTimeout(() => {
            this.setState({notConnected: !ipfs.isConnectedLocally()});
        }, 15000);
    }

    onClickStart() {
        this.setState({
            downloading: true
        });

        this.samplesPinner.pinAll();

        this.interval = setInterval(async () => {
            let stats = this.samplesPinner.getStats()
            let pinning = Array.from(stats.pinning);
            for (let i in pinning) {
                let hash = pinning[i];
                if (hash in this.state.filesDownloading) {
                    continue;
                }
                this.state.filesDownloading[hash] = await
                ethereum.getTitleForSound(hash);

                this.state.tagsDownloading[hash] = await ethereum.getTagsForSound(hash);
            }
            
            this.state.counter++;
            this.state.stats = stats;
            this.setState(this.state);
        }, 500);
    }

    render() {
        let pinning = Array.from(this.state.stats.pinning);
        let x = [];
        for (let i=0; i < 350; i++) {
            x.push(0);
        }

        if (this.state.notConnected) {
            return (
                <div className="downloader">
                  <div className="title">Universal Sequences Downloader</div>
                  <div className="action">
                  In order to download files onto your computer, please run <a href="https://github.com/ipfs-shipyard/ipfs-desktop">IPFS</a>
                  </div>
                </div>
            );
        }

        return (
            <div className="downloader">
              <div className="title">Universal Sequences Downloader</div>
              <div className="divider">
                {x.map(
                (a, i) => this.state.counter % x.length === i ? <span className="current">/</span> : "/")}</div>
 

              <ConditionedComponent condition={!this.state.downloading}>
                <div
                  onClick={() => this.onClickStart()}
                  className="download-start-button">Start</div>
              </ConditionedComponent>
              <ConditionedComponent condition={this.state.downloading && this.state.stats}>
                <div>Downloaded up to: <span className="date">{this.state.stats.date.toString()}</span></div>
                <div>Downloaded: {this.state.stats.pinned.size} </div>
                <div>Queued: {this.state.stats.queued.size} </div>
                <div>Failed : {this.state.stats.failed.size}</div>
              <div className="divider">{x.map(x => "/")}</div>
                <div>Downloading: <span className="file-name">{this.state.stats.pinning.size}</span></div>
                {pinning.map(
                    (hash) =>
                        <div>
                              <span className="action">Downloading</span> <span className="file-name">{this.state.filesDownloading[hash]}...</span>
                                  {(this.state.tagsDownloading[hash] || []).map(x => <span className="tag">{x}</span>)}
                        </div>)}
                <div className="divider">{x.map(x => "/")}</div>
                <div>Local: {this.state.stats.local.size}</div>
              </ConditionedComponent>
            </div>
        );
    }
}

export default PinnerComponent;
